export default "__VITE_PUBLIC_ASSET__e673a7a4__"